export default __webpack_public_path__ + "static/media/PrepRecovery_Img@2x.85b26e22.png";